/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { getTopicInfos } from './asyncThunks'

const initialState = {
  status: 'idle',
  accessibleTopics: [],
  error: null
}

const topicInfoSlice = createSlice({
  name: 'dashboardInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTopicInfos.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(getTopicInfos.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.accessibleTopics = action.payload
      })
      .addCase(getTopicInfos.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
  }
})

export default topicInfoSlice.reducer
